"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get isMuxEnabled () {
        return isMuxEnabled;
    },
    get isSecureAttachmentEnabled () {
        return isSecureAttachmentEnabled;
    },
    get isWorker () {
        return isWorker;
    }
});
const isWorker = process.env.NC_WORKER_CONTAINER === 'true';
const isMuxEnabled = false;
const isSecureAttachmentEnabled = process.env.NC_SECURE_ATTACHMENTS === 'true';
